export var AnimationDirectionType;
(function (AnimationDirectionType) {
    AnimationDirectionType["REVERSE"] = "reverse";
    AnimationDirectionType["NORMAL"] = "normal";
})(AnimationDirectionType || (AnimationDirectionType = {}));
export var AnimationType;
(function (AnimationType) {
    AnimationType["LEFT"] = "left";
    AnimationType["RIGHT"] = "right";
    AnimationType["TOP"] = "top";
    AnimationType["BOTTOM"] = "bottom";
})(AnimationType || (AnimationType = {}));
